var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"_pbiReport",style:(_vm.reportStyle),attrs:{"id":_vm.id,"width":_vm.width}})])}
var staticRenderFns = []

export { render, staticRenderFns }